import { createSlice } from '@reduxjs/toolkit';
import { adminApi } from '@store/api/adminApi';

export type DashboardAccessState = {
  overviewRejected: boolean;
};

const initialState: DashboardAccessState = {
  overviewRejected: false,
};

const dashboardAccessSlice = createSlice({
  name: 'dashboardAccess',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(adminApi.util.resetApiState, () => initialState)
      .addMatcher(adminApi.endpoints.getStatsOverview.matchRejected, (state, action) => {
        const error = action.payload;
        if (error && typeof error === 'object' && 'status' in error &&
          (error.status === 401 || error.status === 403)) {
          state.overviewRejected = true;
        }
      })
      .addMatcher(adminApi.endpoints.getStatsOverview.matchFulfilled, state => {
        // Pending retries and non-auth failures do not reauthorize cached data.
        state.overviewRejected = false;
      });
  },
});

export const selectDashboardAccessRejected = (state: { dashboardAccess: DashboardAccessState }) =>
  state.dashboardAccess.overviewRejected;

export default dashboardAccessSlice.reducer;
